import { useState } from "react";
import type { FamilyMember, Category } from "@/types";
import { Modal } from "@/components/Modal/Modal";
import styles from "./Sidebar.module.css";

interface SidebarProps {
  members: FamilyMember[];
  categories: Category[];
  activeMemberId: string;
  activeCategoryName: string | null;
  disabled?: boolean;
  onMemberSelect: (memberId: string) => void;
  onCategorySelect: (categoryName: string) => void;
  onAddMember: () => void;
  onShare: () => void;
  onLogout: () => void;
}

export function Sidebar({
  members,
  activeMemberId,
  onMemberSelect,
  onShare,
  onLogout,
  disabled
}: SidebarProps) {
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);

  return (
    <>
      <aside className={styles.sidebar}>
        <div className={styles.logoWrap}>
          <span className={styles.logo}>Closai</span>
        </div>

        <div className={styles.section}>
          <div className={styles.label}>Closets</div>
          {members.map((member) => (
            <button
              key={member.id}
              className={[styles.item, activeMemberId === member.id ? styles.itemActive : ""].filter(Boolean).join(" ")}
              onClick={() => onMemberSelect(member.id)}
            >
              <span className={styles.avatar} style={{ background: member.color }}>
                {member.icon}
              </span>
              <span className={styles.itemText}>{member.name}</span>
            </button>
          ))}
          {/* <button className={styles.addBtn} onClick={onAddMember}>
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="12" y1="5" x2="12" y2="19" />
              <line x1="5" y1="12" x2="19" y2="12" />
            </svg>
            <span className={styles.addText}>Add member</span>
          </button> */}
        </div>

        <div className={styles.divider} />

        {/* TODO bring back later */}
        {/* <div className={styles.section}>
          <div className={styles.label}>Categories</div>
          {categories.map((cat) => (
            <button
              key={cat.name}
              className={[styles.item, activeCategoryName === cat.name ? styles.itemActive : ""]
                .filter(Boolean)
                .join(" ")}
              onClick={() => onCategorySelect(cat.name)}
            >
              <span className={styles.catIcon}>{cat.icon}</span>
              <span className={styles.itemText}>{cat.name}</span>
              <span className={styles.count}>{cat.count}</span>
            </button>
          ))}
        </div> */}

        <div className={styles.footer}>
          <button className={styles.footerBtn} disabled={disabled} onClick={onShare}>
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <circle cx="18" cy="5" r="3" />
              <circle cx="6" cy="12" r="3" />
              <circle cx="18" cy="19" r="3" />
              <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" />
              <line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
            </svg>
            <span className={styles.footerText}>Share</span>
          </button>
          <button className={[styles.footerBtn, styles.logoutBtn].join(" ")} onClick={() => setShowLogoutConfirm(true)}>
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4" />
              <polyline points="16 17 21 12 16 7" />
              <line x1="21" y1="12" x2="9" y2="12" />
            </svg>
            <span className={styles.footerText}>Log out</span>
          </button>
          <a href="mailto:contact@closai.io" className={styles.supportLink}>
            Need help? Contact us at contact@closai.io
          </a>
        </div>
      </aside>

      <Modal
        open={showLogoutConfirm}
        onClose={() => setShowLogoutConfirm(false)}
        title="Log out"
        maxWidth={400}
      >
        <p className={styles.logoutMessage}>Are you sure you want to log out?</p>
        <div className={styles.logoutActions}>
          <button
            className={styles.cancelBtn}
            onClick={() => setShowLogoutConfirm(false)}
          >
            Cancel
          </button>
          <button
            className={styles.confirmLogoutBtn}
            onClick={() => {
              setShowLogoutConfirm(false);
              onLogout();
            }}
          >
            Log out
          </button>
        </div>
      </Modal>
    </>
  );
}
